import { createReducer, on } from '@ngrx/store';

import {
	authentication,
	revokeAuthentication,
	revokeAuthentication401,
	setName,
	setRoles,
	setPrivileges,
	setSessionParams,
	setUsername,
	setUserId,
} from './auth.actions';

import { ApplicationType } from 'shared/openapi/models/application-type';

export interface IAuthStore {
	app: string;
	name: string | undefined;
	username: string | undefined;
	userId: string | undefined;
	roles: string[] | undefined;
	authenticated: boolean | undefined;
	privileges: string[] | undefined;
	sessionPeriod?: number;
	unauthorized: boolean | undefined;
}

const initialState = (app: ApplicationType): IAuthStore => ({
	app,
	name: undefined,
	username: undefined,
	userId: undefined,
	roles: undefined,
	authenticated: undefined,
	privileges: undefined,
	sessionPeriod: 0,
	unauthorized: undefined,
});

export const authReducer = (app: ApplicationType) =>
	createReducer(
		initialState(app),
		on(setName, (state: IAuthStore, { payload }) => ({
			...state,
			name: payload.name,
		})),
		on(setUsername, (state: IAuthStore, { payload }) => ({
			...state,
			username: payload.username,
		})),
		on(setUserId, (state: IAuthStore, { payload }) => ({
			...state,
			userId: payload.userId,
		})),
		on(setRoles, (state: IAuthStore, { payload }) => ({
			...state,
			roles: payload.roles,
		})),
		on(authentication, (state: IAuthStore) => ({
			...state,
			authenticated: true,
			unauthorized: false,
		})),
		on(revokeAuthentication, (state: IAuthStore) => ({
			...state,
			authenticated: false,
			privileges: [],
			roles: [],
			unauthorized: false,
		})),
		on(revokeAuthentication401, (state: IAuthStore) => ({
			...state,
			authenticated: false,
			privileges: [],
			roles: [],
			unauthorized: true,
		})),
		on(setPrivileges, (state: IAuthStore, { payload }) => ({
			...state,
			privileges: payload.privileges,
		})),
		on(setSessionParams, (state: IAuthStore, { payload }) => ({
			...state,
			sessionPeriod: payload.sessionPeriod,
		}))
	);
